module.exports = __webpack_public_path__ + "static/media/Spinner.707f6970.svg";